import { useEffect, useRef, useState } from "react";
import "./emp-footer.scss";
import logo from "../../../assets/images/logo.svg"

const EmpFooter = () => {


    const pageWrapperRef = useRef<HTMLDivElement>(null)

    return (<div className="emp-footer" ref={pageWrapperRef}>
        <section>
            <span className="copyright">© EMERGE ESports</span>
            <div className="link-wrapper">
                <ul>
                    <li className="menu-item">
                        <span>Home</span>
                    </li>
                    <li className="menu-item">
                        <span>Pricing</span>
                    </li>
                    <li>
                        <span>Free Trial</span>
                    </li>
                </ul>
            </div>
        </section>
    </div>)

}
export default EmpFooter